// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1-lgD","sendOtp":"AuthorizeToLogin_sendOtp__1wG9w"};